import { DashboardConfig, PartialDashboard, SidebarType, Subscription, SubscriptionType } from './types'

export const DashboardDefaultLayout: Record<PartialDashboard, DashboardConfig> = {
  [PartialDashboard.EmergencyQuickAccess]: {
    col: { xs: 16, sm: 12 },
  },
  [PartialDashboard.Agenda]: {
    col: { xs: 12, md: 8 },
  },
  [PartialDashboard.Welcome]: {
    col: { xs: 12, sm: 8 },
  },
  [PartialDashboard.ConsultationsStatistics]: {
    col: { xs: 12, sm: 4 },
  },
  [PartialDashboard.Patients]: {
    col: { xs: 12, md: 4 },
  },
  [PartialDashboard.ExpertiseAndConsultationsTab]: {
    col: { xs: 12, md: 8 },
  },
  [PartialDashboard.Consultations]: {
    col: { xs: 12, sm: 8 },
  },
  [PartialDashboard.Expertises]: {
    col: { xs: 12, sm: 8 },
  },
  [PartialDashboard.FavoriteWaitingRooms]: {
    col: { xs: 12, md: 8 },
  },
  [PartialDashboard.WaitingRoom]: {
    col: { xs: 12, md: 8 },
  },
  [PartialDashboard.Equipments]: {
    col: { xs: 20, md: 12 },
  },
  [PartialDashboard.LocalConsultation]: {
    col: { xs: 12, md: 8 },
  },
  [PartialDashboard.ExamsStatistics]: {
    col: { xs: 12, sm: 4 },
  },
  [PartialDashboard.MeetingLinksStatistics]: {
    col: { xs: 12, md: 4 },
  },
  [PartialDashboard.ShiftDashboard]: {
    col: { xs: 12, md: 4 },
  },
}

// Subscription utils

export const DefaultSubscription: Record<SubscriptionType, Subscription> = {
  PDS_ALL_ACCESS: {
    sidebar: [
      SidebarType.Onboarding,
      SidebarType.Home,
      SidebarType.Patients,
      SidebarType.Calendar,
      SidebarType.MeetingLinks,
      SidebarType.Expertises,
      SidebarType.Consultations,
      SidebarType.Emergency,
      SidebarType.WaitingRooms,
      SidebarType.Staffs,
    ],
    dashboard: [
      PartialDashboard.Welcome,
      PartialDashboard.ConsultationsStatistics,
      PartialDashboard.EmergencyQuickAccess,
      PartialDashboard.Patients,
      PartialDashboard.ExpertiseAndConsultationsTab,
      PartialDashboard.MeetingLinksStatistics,
      PartialDashboard.Agenda,
    ],
    type: SubscriptionType.PDS_ALL_ACCESS,
  },
  MED_ALL_ACCESS: {
    sidebar: [
      SidebarType.Onboarding,
      SidebarType.Home,
      SidebarType.Patients,
      SidebarType.Calendar,
      SidebarType.MeetingLinks,
      SidebarType.Expertises,
      SidebarType.Consultations,
      SidebarType.EmergenciesMed,
      SidebarType.WaitingRooms,
      SidebarType.Staffs,
    ],
    dashboard: [
      PartialDashboard.Welcome,
      PartialDashboard.ConsultationsStatistics,
      PartialDashboard.Patients,
      PartialDashboard.ExpertiseAndConsultationsTab,
      PartialDashboard.MeetingLinksStatistics,
      PartialDashboard.Agenda,
    ],
    type: SubscriptionType.MED_ALL_ACCESS,
  },
  MED_GUEST: {
    sidebar: [SidebarType.Home, SidebarType.Patients, SidebarType.Consultations, SidebarType.Calendar],
    dashboard: [PartialDashboard.Welcome, PartialDashboard.ConsultationsStatistics, PartialDashboard.ExpertiseAndConsultationsTab, PartialDashboard.Patients],
    type: SubscriptionType.MED_GUEST,
  },
  MED_BASIC: {
    sidebar: [SidebarType.Onboarding, SidebarType.Home, SidebarType.Patients, SidebarType.Calendar, SidebarType.LocalConsultations],
    dashboard: [
      PartialDashboard.Welcome,
      PartialDashboard.ExamsStatistics,
      PartialDashboard.Equipments,
      PartialDashboard.Patients,
      PartialDashboard.LocalConsultation,
    ],
    type: SubscriptionType.MED_BASIC,
  },
  ADMIN: {
    sidebar: [
      SidebarType.AdminStaffs,
      SidebarType.AdminGroups,
      SidebarType.AdminPlugin,
      SidebarType.AdminPlannings,
      SidebarType.AdminEstablishment,
      SidebarType.AdminStatistics,
      SidebarType.AdminLicenses,
      SidebarType.AdminPolicies,
      SidebarType.AdminApiKeys,
    ],
    dashboard: [],
    type: SubscriptionType.ADMIN,
  },
  SUPER_ADMIN: {
    sidebar: [
      SidebarType.SuperAdminHome,
      SidebarType.SuperAdminMeetingLinks,
      SidebarType.SuperAdminWaitingRooms,
      SidebarType.SuperAdminStatistics,
      SidebarType.SuperAdminContracts,
      SidebarType.SuperAdminLicenses,
      SidebarType.SuperAdminPolicies,
      SidebarType.SuperAdminApiKeys,
      SidebarType.SuperAdminSettings,
    ],
    dashboard: [],
    type: SubscriptionType.SUPER_ADMIN,
  },
  CUSTOM: {
    sidebar: [],
    dashboard: [],
    type: SubscriptionType.CUSTOM,
  },
  NO_SUBSCRIPTION: {
    sidebar: [],
    dashboard: [],
    type: SubscriptionType.NO_SUBSCRIPTION,
  },
}
